import styled from "styled-components"

export default function ProductInfoContent({ scrollRef, onScroll, children }) {
  return (
    <Content ref={scrollRef} onScroll={onScroll}>
      {children}
    </Content>
  )
}

const Content = styled.div`
  flex: 1 1 auto;
  overflow-y: scroll;
`
